import { createAction, props } from "@ngrx/store";
import { Result } from '../../shared/models/core/result.model';
import { User } from '../../shared/models/user.model';

export const findUsers = createAction(
    '[User Management] Find Users',
    props<{ page: number, size: number, keywords: string }>()
);

export const findUsersSuccess = createAction(
    '[User Management] Find Users Success',
    props<{ users: Result<User> }>()
);

export const findUsersError = createAction(
    '[User Management] Find Users Error',
    props<{ error: any }>()
);

// Create User
export const createUser = createAction(
    '[User Management] Create User',
    props<{ user: User }>()
);

export const createUserSuccess = createAction(
    '[User Management] Create User Success',
    props<{ user: User }>()
);

export const createUserError = createAction(
    '[User Management] Create User Error',
    props<{ error: any }>()
);

// Update User
export const updateUser = createAction(
    '[User Management] Update User',
    props<{ id: number | string, user: Partial<User> }>()
);

export const updateUserSuccess = createAction(
    '[User Management] Update User Success',
    props<{ user: User }>()
);

export const updateUserError = createAction(
    '[User Management] Update User Error',
    props<{ error: any }>()
);

// Delete User
export const deleteUser = createAction(
    '[User Management] Delete User',
    props<{ id: number | string }>()
);

export const deleteUserSuccess = createAction(
    '[User Management] Delete User Success',
    props<{ id: number | string }>()
);

export const deleteUserError = createAction(
    '[User Management] Delete User Error',
    props<{ error: any }>()
);
